import { render } from "./EmployeeAttendsdetails.vue?vue&type=template&id=b4291e94"
import script from "./EmployeeAttendsdetails.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendsdetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__